import { environmentCommon } from "./environment-common";

export const environment = {
  ...environmentCommon,
  production: true,
  hmr: false,
  enableSW: true,
  oneSignalAppId: "57f6c918-63ea-4de5-a097-87c402a22ab2"
};
